import { Grid, Card, Box, FormControl, FormHelperText } from "@mui/material";
import { ExamQuestionModel } from "../../Utils/Models";

interface Props {
  question: ExamQuestionModel;
  selected?: number[];
  showResult?: boolean | undefined | "";
  handleSelect?: (idx: number) => void;
  error?: string | null;
  disabled?: boolean;
}

export default function ExamAnswers({
  question,
  selected,
  showResult,
  handleSelect,
  error,
  disabled,
}: Props) {
  return (
    <FormControl error={!!error} fullWidth>
      <Grid container spacing={2} justifyContent="center">
        {question.answers.map((ans, idx) => {
          let bg = "#fff";
          if (showResult) {
            if (ans.isCorrect) bg = "#d4edda"; // green for correct
            if (!ans.isCorrect && selected?.includes(idx)) bg = "#ffcdd2"; // red for wrong
          } else if (selected?.includes(idx)) {
            bg = "#fff9c4"; // yellow for selected
          }
          return (
            <Grid item xs={12} md={12} lg={10} key={idx}>
              <Card
                onClick={() => {
                  if (!showResult && !selected?.includes(idx) && handleSelect)
                    handleSelect(idx);
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: showResult ? "default" : "pointer",
                  minHeight: 56,
                  borderLeft: selected?.includes(idx)
                    ? "7px solid #fbc02d"
                    : "7px solid transparent",
                  background: bg,
                  opacity:
                    showResult && !selected?.includes(idx) && !ans.isCorrect
                      ? 0.7
                      : 1,
                  transition: "all 0.2s",
                }}
              >
                <Box
                  width={80}
                  fontWeight="bold"
                  fontSize="1.7rem"
                  textAlign="center"
                  color="#3b3e66"
                  bgcolor="#e5e6e7"
                  py={disabled ? 1 : 6}
                >
                  {String.fromCharCode(65 + idx)}
                </Box>
                <Box flex={1} py={2} pl={3} color="#3b3e66">
                  {ans.text}
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
